import * as Tone from "tone"
let inst = {};
let getRand = (arr) => arr[Math.floor(Math.random() * arr.length)]

let samples = [{
    'A2': 'scale-A2.[mp3|ogg]',
    'A3': 'scale-A3.[mp3|ogg]',
    'C3': 'scale-C3.[mp3|ogg]',
    'C4': 'scale-C4.[mp3|ogg]',
    'D3': 'scale-C3.[mp3|ogg]',
    'D4': 'scale-D4.[mp3|ogg]',
    'E3': 'scale-E3.[mp3|ogg]',
    'E4': 'scale-E4.[mp3|ogg]',
    'G2': 'scale-G2.[mp3|ogg]',
    'G3': 'scale-G3.[mp3|ogg]',
}, {
    'attack': 0.001,
    'release': 0.3,
    'baseUrl': './teropa/'
}]


let delayL = new Tone.PingPongDelay("32n", 0.85)
let delayR = new Tone.PingPongDelay("32n", 0.78)

delayL.wet.value = 0.2;
delayR.wet.value = 0.2;
let meterL = new Tone.Meter();
let meterR = new Tone.Meter();
let defaultFreq = 50
let filterL = new Tone.Filter(defaultFreq, "highpass", -24);
let filterR = new Tone.Filter(defaultFreq, "highpass", -24);

let pannerL1 = new Tone.Panner(-0.0).toDestination()
let pannerL2 = new Tone.Panner(-1.0).toDestination()
let pannerL3 = new Tone.Panner(-0.2).toDestination()
let pannerR1 = new Tone.Panner(0.9).toDestination()
let pannerR2 = new Tone.Panner(0.5).toDestination()
let pannerR3 = new Tone.Panner(0.2).toDestination()
let pannerR4 = new Tone.Panner(0.9).toDestination()
let synthL = new Tone.Sampler(...samples)
let synthR = new Tone.Sampler(...samples)
synthL.volume.value = -15
synthR.volume.value = -15
synthL.connect(delayL)
synthR.connect(delayR)

delayL.connect(filterL)
delayR.connect(filterR)
filterL.connect(pannerL1)
filterL.connect(pannerL2)
filterL.connect(pannerL3)
filterR.connect(pannerR1)
filterR.connect(pannerR2)
filterR.connect(pannerR3)

delayL.connect(meterL)
delayR.connect(meterR)

Tone.Transport.bpm.value = 60;

inst = {
    delayL,
    delayR,
    filterL,
    filterR,
    synthL,
    synthR,
    meterL,
    meterR,
    defaultFreq,
    ready: 0,
    drone: undefined,
    bell: undefined
}
export default inst
